import  Button  from "@mui/material/Button"
import { Tour } from "react-shepherd"
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useRef, useState } from "react";
import { DetectFramework } from "../../AppFiles/detectGlobal";

const options = ['Help Tour', 'General Help','Link'];

type ArgHelpButton= {
    tourContext: Tour|null
}
function HelpButton({tourContext}: ArgHelpButton){

    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
  
    const handleClick = (index: number|null) => {
        if(index == null) index= selectedIndex;
      
      switch(index ){
        case 0:
            if(tourContext) tourContext.start(); else window.alert('not tour context');
            return;
        case 1:
            window.open(`${new DetectFramework().baseUrl()}/help/index.html` ); 
            return;
        case 2:
            window.open(`https://github.com/ignatandrei/blocklyautomation` );
            return;
        default:
            window.alert('not a good option for help!');
            // window.open(`${process.env.PUBLIC_URL}/help/index.html`);
      }
    };
  
    const handleMenuItemClick = (
      event: React.MouseEvent<HTMLLIElement, MouseEvent>,
      index: number,
    ) => {
      setSelectedIndex(index);
      setOpen(false);
      handleClick(index);
    };
  
    const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
    };
  
    const handleClose = (event: Event) => {
      if (
        anchorRef.current &&
        anchorRef.current.contains(event.target as HTMLElement)
      ) {
        return;
      }
  
      setOpen(false);
    };
  
    return (
      <>
        <ButtonGroup className='btnHelp' variant="contained" ref={anchorRef} aria-label="split button">
          <Button onClick={()=>handleClick(null)}>{options[selectedIndex]}</Button>
          <Button
            size="small"
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          sx={{
            zIndex: 1,
          }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        disabled={index === 200}
                        selected={index === selectedIndex}
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    );

    // return <>
    // <Button variant="contained" onClick={()=>tourContext!.start()}>
    //         Help tour!
    // </Button>

    // </>

}

export default HelpButton;